import { AxiosResponse } from 'axios'
import { NewsDetail } from 'src/types/news'

import axios from '../../axios'

export const fetchNews = async (id: string): Promise<AxiosResponse> => {
  const response = await axios
    .get<{ data: NewsDetail }>(`/api/news/${id}`)
    .catch((error) => {
      return error.response
    })

  return response
}
